'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Placeholder = function Placeholder(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? '#000' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 580 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 110 : _ref$height;
  return _react2.default.createElement(
    'svg',
    { focusable: 'false', viewBox: '0 0 ' + width + ' ' + height, preserveAspectRatio: 'xMinYMin meet', className: 'icon-svg-table-placeholder pulse responsive', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { fill: color, d: 'M0 0h580v10H0zm0 20h580v10H0zm0 60h580v10H0zm0 20h580v10H0zm0-60h580v10H0zm0 20h580v10H0z' })
  );
};

Placeholder.propTypes = {
  color: _react.PropTypes.string.isRequired,
  width: _react.PropTypes.number.isRequired,
  height: _react.PropTypes.number.isRequired
};

exports.default = Placeholder;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-table/lib/components/placeholder/components/Placeholder.component.js
// module id = 1347
// module chunks = 1